import React from 'react';
import {
    QuestionsAndAnswersItemInterface
} from 'modules/product/views/components/product-questions-answers/interfaces/questions-and-answers-item.interface';

interface AnswerStructuredDataInterface {
    '@type': string;
    text: string;
}

interface QuestionStructuredDataInterface {
    '@type': string;
    name: string;
    acceptedAnswer: AnswerStructuredDataInterface;
}

interface QuestionsAnswersStructuralDataProps {
    questions: QuestionsAndAnswersItemInterface[];
}

const QuestionsAnswersStructuralData: React.FC<QuestionsAnswersStructuralDataProps> = ({ questions }) => {
    if (!questions?.length) {
        return null;
    }

    const mainEntity = questions.reduce((questions: QuestionStructuredDataInterface[], question) => {
        if (!question.children?.length) {
            return questions;
        }

        return [
            ...questions,
            {
                '@type': 'Question',
                'name': question.text,
                'acceptedAnswer': {
                    '@type': 'Answer',
                    'text': question.children[0].text
                }
            }
        ];
    }, []);

    const data = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
    );
};

export default QuestionsAnswersStructuralData;
